// packages/ui/src/components/security/SecuritySettingsTab.tsx
//
// R3-3 (2026-05-16) — Security Settings tab: 2FA wizard link,
// password change link, login-alert toggle, API-key rotation pointer.

import { type JSX } from 'react';

import { useAuth } from '../../hooks/useAuth.js';

export function SecuritySettingsTab(): JSX.Element {
  const user = useAuth((s) => s.user);
  const twoFaEnabled =
    (user as unknown as { twoFactorEnabled?: boolean } | null)
      ?.twoFactorEnabled === true;

  return (
    <div className="space-y-4" data-testid="security-settings-tab">
      <section className="space-y-1 rounded-md border border-pw-border bg-pw-bg p-4">
        <div className="flex items-center justify-between gap-3">
          <div className="min-w-0">
            <h3 className="text-sm font-semibold text-pw-text">
              Xác thực 2 yếu tố (2FA)
            </h3>
            <p className="text-xs text-pw-text-muted">
              {twoFaEnabled
                ? 'Đã bật. Ứng dụng xác thực sẽ tạo mã 6 số mỗi lần đăng nhập.'
                : 'Chưa bật. Bật để chặn truy cập khi mật khẩu bị lộ.'}
            </p>
          </div>
          <a
            href="/settings/2fa"
            className="rounded-md border border-pw-border bg-pw-surface px-3 py-1.5 text-xs font-medium text-pw-text hover:bg-pw-bg"
          >
            {twoFaEnabled ? 'Quản lý' : 'Bật 2FA'}
          </a>
        </div>
      </section>

      <section className="space-y-1 rounded-md border border-pw-border bg-pw-bg p-4">
        <div className="flex items-center justify-between gap-3">
          <div className="min-w-0">
            <h3 className="text-sm font-semibold text-pw-text">Đổi mật khẩu</h3>
            <p className="text-xs text-pw-text-muted">
              Mật khẩu mạnh ≥ 12 ký tự, có chữ hoa, số, ký tự đặc biệt.
            </p>
          </div>
          <a
            href="/settings/change-password"
            className="rounded-md border border-pw-border bg-pw-surface px-3 py-1.5 text-xs font-medium text-pw-text hover:bg-pw-bg"
          >
            Đổi mật khẩu
          </a>
        </div>
      </section>

      {/* R5-4 (2026-05-16) — login alert toggle + API keys page removed
          until BE prefs schema lands (current /me/notification-prefs
          shape doesn't model per-event toggles; the toggle previously
          PATCHed an unsupported `matrix.security.login_new_device` body
          → 400 error). */}
      <section className="space-y-1 rounded-md border border-dashed border-pw-border bg-pw-surface p-4">
        <h3 className="text-sm font-semibold text-pw-text">
          Cảnh báo đăng nhập mới · Khoá API · IP allowlist
        </h3>
        <p className="text-xs text-pw-text-muted">
          Các tính năng này đang xếp lịch trong roadmap (Phase 8.2). Hiện hệ
          thống đã ghi audit log mọi lần đăng nhập — xem ở tab Activity Log.
        </p>
      </section>
    </div>
  );
}

export default SecuritySettingsTab;
